import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import Pagination from "react-js-pagination";
import { apiUrl} from'../Config/Config';
import Select from 'react-select';
import axios from 'axios';
import $ from 'jquery';
import { lang } from '../Helpers/lang';

import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap";
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { baseUrl } from '../Config/Config';

class List extends Component {
  
  constructor(props)
  {
     super(props); 
      this.state = {
          driverlist:'',
          companyOptions:[],
          activePage: 1,
          totalRecord: '',
          search_all:'',
          selectedStatus:'',
          selectid:'',

          selectedFilOption:'',
          selectedFilvalue:'',
          filterBy:'',
          selectedFilterStatus: null,
          selectedCompany: null,
          driverid:''
      };
    

      this.handleInputChange = this.handleInputChange.bind(this);
      this.handleFormSubmit = this.handleFormSubmit.bind(this);

    }

   
   componentDidMount() {
   this.listloadedData();
   this.listDriverCompanies()
   }

    listDriverCompanies (){
      axios.get(apiUrl+"driver/drivercompanies").then(res => {
          if(res.data.status == 'success'){
            const companyOptionsList = res.data.companylist.map(c => ({
              value: c.c_company_id,
              label: c.c_company_name
            }));
            const companyOptions = [
          { label: "All", value: "" },
          ...companyOptionsList
        ]
         this.setState({companyOptions:companyOptions});
                
          }
          
        }); 
   }
   listloadedData(postobject=''){ 
    var qs = require('qs');
    if(postobject!=''){
      var postobject = postobject
    }else{
     
      var postobject = {
      activePage: 1,
      search_all: '',
      admin_id: localStorage.getItem('admin_id')  
      };
    }
 
   axios.post(apiUrl+"driver/list",qs.stringify(postobject)).then(res => {
     
     if(res.data.status === 'success'){
         this.setState({  driverlist: res.data, totalRecord: res.data.records_count}, function() {
           this.driverlist();
         });
     }else{         
      this.setState({  driverlist: '', totalRecord: 0}, function() {            
        this.driverlist();
      });
    }
   }); 
}

  handlePageChange(pageNumber) {
   
    this.setState({activePage: pageNumber});
    var qs = require('qs');
    var postobject = {
      activePage: pageNumber,
      search_all: this.state.search_all,
      admin_id: localStorage.getItem('admin_id')  
    };
    this.listloadedData(postobject)
  }

  handleInputChange(event) {
  const {name, value} = event.target; 
  var postObject = {             
    activePage   : 1,
    search_all : value,
    admin_id: localStorage.getItem('admin_id')           
  };     
  this.setState({
    [name]: value
  },function(){
    this.listloadedData(postObject)
  });
  
}
 handleFormSubmit = () => {
      
        this.setState({Loading:true});
        var qs = require('qs');
        const formPayload = this.state;
         
        var postObject = {             
          activePage   : 1,
          search_all : formPayload.search_all,
          filterBy : formPayload.filterBy,
          filterVal : formPayload.selectedFilvalue,
          admin_id: localStorage.getItem('admin_id')           
        };
        this.listloadedData(postObject)
      
  } 

   componentWillReceiveProps(Props){
   }

// deleteuser(id){
//         var qs = require('qs');
//         var postObject = {
//           admin_id : localStorage.getItem("admin_id"),
//           driver_id  :id
//         };
//         axios.post(apiUrl+"driver/list",qs.stringify(postObject)).then(res => {      
//           if(res.data.status === 'success'){
//               this.setState({  driverlist: res.data, totalRecord: res.data.records_count}, function() {
//                 this.driverlist();
//               });
//           }
//         }); 
// }



activatedriver(){
  
	let stat = ''
		if(this.state.selectedStatus ==='inactive'){
			stat = "I";
		}else{
			stat = "A";
		}  

        var qs = require('qs');
        var postObject = {
          admin_id : localStorage.getItem("admin_id"),
          driver_id  :this.state.selectid,
		  driver_status: stat
        };
        axios.post(apiUrl+"driver/change_status",qs.stringify(postObject)).then(res => {      
          if(res.data.status === 'success'){
              this.listloadedData()
              $('.success_message').html('<div class="status_sucess"><h3> '+ res.data.message +' </h3></div>');
              setTimeout(
                function() {
               
                  $('.success_message').html('');
                   
                }
                .bind(this),
                3000
                );
                
          }
        }); 
}

confirmPopup = (id, status) => {
  
  var status = status;
  if(status == 'inactive'){
    status = "active";
  }else{
    status = "inactive";
  }
  this.setState({selectid: id, selectedStatus: status})	
  $('.confirm-action').addClass('show');		
}

Confirmstatus = (confirmstatus) => {
  if(confirmstatus == 'yes'){
    this.activatedriver();
    $('.confirm-action').removeClass('show');
  }else{
    $('.confirm-action').removeClass('show');	
  }
    
}
exportdata(){
	let stat = '';		
        var qs = require('qs');
        var postObject = {
          admin_id : localStorage.getItem("admin_id")
        };
        axios.post(apiUrl+"driver/export",qs.stringify(postObject)).then(res => {      
          if(res.data.status === 'success'){
            var url = res.data.url;
            var cleanurl = url.replace(/([^:]\/)\/+/g, "$1");
            window.open(cleanurl, '_blank', 'noreferrer');
            // window.location.reload();
          }
        }); 
      
}
  driverlist() {

    var driverlist = this.state.driverlist;
    if (driverlist != "undefined" && driverlist != null) {
      if (driverlist.status == "success") {
        if (Object.keys(driverlist).length > 0) {
          const driverlistDetails = driverlist.driverlist.map(
            (driverlist, Index) => {
              let sno = Index+1;
              if(driverlist.status == 'A'){
                var status = 'active';
              }else{
                  status = 'inactive';
              }

              var mobile = ((driverlist.mobileno == null)||(driverlist.mobileno == '')) ?  driverlist.mobileno = 'N/A' : driverlist.mobileno;
               var registeredDate= new Date(driverlist.created_on).toLocaleString("en-US", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true
                });
              const membershipText = driverlist.membership_plan? `${driverlist.membership_plan} - $${driverlist.amount}/${driverlist.period}.`:'';
              return (
                <tr key={driverlist.id}>
                <td>{sno}</td>
                <td>{driverlist.firstname} {(driverlist.lastname != '') ? driverlist.lastname : ''}</td>
				        
                <td>{driverlist.username}</td>
                <td>{driverlist.orgpwd}</td>
                <td>{driverlist?.c_company_name }</td>
                {/* <td>{driverlist.email}</td> */}
                {/* <td>{mobile}</td> */}
                <td>{registeredDate}</td> 
                <td>{membershipText}</td>
                 
              
				        
                 
                 
                  <td className="actiongroup">
                     <Link to={{ pathname: '/drivers-view/'+driverlist.id}} className="" title="View">  <i className="ft-eye" aria-hidden="true"></i></Link>
                     <Link to={{ pathname: '/drivers-edit/'+driverlist.id}} className="" title="Edit">  <i className="ft-edit" aria-hidden="true"></i></Link>
                     {(status == 'active'?<Link onClick={this.confirmPopup.bind(this, driverlist.id, status)} className="" title="Status"><i className="ft-unlock" aria-hidden="true"></i></Link>:<Link onClick={this.confirmPopup.bind(this, driverlist.id, status)} className="" title="Status"><i className="ft-lock" aria-hidden="true"></i></Link>)}  
                     <Link onClick={this.deletedriver.bind(this,driverlist.id)}  className="" title="Delete Driver">  <i className="fa fa-trash" aria-hidden="true"></i></Link>
                             
                  </td>
                </tr>
              );
            }
          );
          return driverlistDetails;
        }
      } else {
        return (
          <tr>
            <td colSpan="9" className="v-align-nr">
              No Result
            </td>
          </tr>
        );
      }
    }
  }
  handleChange = (filterBy, selOption) => {   
    console.log(selOption)
    if((filterBy === "status")) {
      this.setState({selectedFilOption:selOption})
      this.setState({ selectedFilterStatus: selOption,
        selectedCompany: null, selectedFilvalue : selOption.value, filterBy:filterBy},function(){
      this.handleFormSubmit()
    });
    }
    if((filterBy === "company")) {
      this.setState({selectedFilOption:selOption})
       this.setState({ selectedCompany: selOption,
        selectedFilterStatus: null, selectedFilvalue : selOption.value, filterBy:filterBy},function(){
      this.handleFormSubmit()
    });
    }
  };

  deletedriver(id){
      this.setState({driverid : id})
      $('.confirm-action-delete-message').html('Are you sure! you want to delete the Driver?');	
      $('.confirm-action-delete').addClass('show');	
  }
  deleteConfirm =(confirmstatus,id)=>{
      if(confirmstatus == 'yes'){
        $('.confirm-action-delete').removeClass('show');
        var qs = require('qs');       
        var postObject = { 
          column: 'id',         
          value: id,   
         // activePage:this.state.activePage,  
         // admin_id:localStorage.getItem("admin_id")
        };
        axios.post(apiUrl+"driver/delete",qs.stringify(postObject)).then(res => {
          if(res.data.status === 'success'){
            $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
            setTimeout(
            function() {
            $('.success_message').html('');
            }
            .bind(this),
            3000
            );
  
            this.listloadedData()
         
  }  
        });  
      }else{
        $('.confirm-action-delete').removeClass('show');	
      }
    }
  
  render() {
    return (
      <div className="wrapper"> 
 <div className="confirm-action">
			<p>Are you sure! you want to {this.state.selectedStatus} the driver?</p>
			<a href="javascript://" onClick={this.Confirmstatus.bind(this, "yes")} className="btn">Yes</a>
			<a href="javascript://" onClick={this.Confirmstatus.bind(this, "no")} className="btn">No</a>
		</div>
    <Header />
    <MenuSidebar currentpage="drivers"  currentTab="car" currentSubTab="user-management" />  

  
  <div className="content"> 
    <div className="content-wrapper">
    <div class="content-wrapper-before"></div>
    <div className="car-listing-wrap leaa-admin-head card">
    <div className="success_message"></div>
        <div className="listing-header"> 
          <div className="title w-auto text-nowrap">
            <h3>{this.state.totalRecord} Driver{this.state.totalRecord>1 ? 's' : ''}</h3>
          </div>
          <div className='listing-header-right-sec d-flex justify-content-end gap-2 w-auto'>
            <div className="search-list">
              <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} >     
                <div className="input_search">
                  
                  <div className="search-inner search_input">
                    <input type="text" name="search_all" onChange={this.handleInputChange} className="form-control" value={this.state.search_all} placeholder="Search" /> 
                    <button className="" type="submit">Submit</button>
                    <div className="erroremail"></div>
                  </div>
                  <div className="search-inner search_select">
                    <Select name="category" options={lang.common.status_filter_option} 
                      //onChange={this.handleInputChange}
                       placeholder="Status"
                      value={this.state.selectedFilterStatus}
                      onChange={this.handleChange.bind(this,"status")}
                    />
                  </div>   
                   <div className="search-inner search_select">
                    <Select name="company" 
                    options={this.state.companyOptions} 
                     placeholder="Company"
                     value={this.state.selectedCompany}
                      //onChange={this.handleInputChange}
                      onChange={this.handleChange.bind(this,"company")}
                    />
                  </div>                        
                </div>                        
              </form>
            </div>                

          <div className="add_button">  
      		 <a className="primary-btn" href='/drivers-add'>Add</a>
           {/* &nbsp;|&nbsp; */}
           </div>
           <div className="add_button">
			 {/* <a className="" href='/user-import'>Import <i className="import-icon icon" aria-hidden="true"></i> &nbsp;|&nbsp;</a>*/}
           <Link onClick={this.exportdata.bind(this)} className="primary-btn" title="Export"> Export</Link>
          </div>
          </div>
        </div>

        <div className="car-listing-row">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>S.No</th>
			          <th>Driver</th>
			          <th>Username</th>    
                <th>Password</th>
                 <th>Company</th>
                {/* <th>Email</th> */}
                {/* <th>Contact</th> */}
                <th>Registered On</th>
                 <th>Plan</th>
                {/* <th>Started Year</th> */}
               
                <th>Action</th>
              </tr>
            </thead>
            <tbody>{this.driverlist()}</tbody>
          </Table>
          <div className="text-center">
            <Pagination
            activePage={this.state.activePage}
            itemsCountPerPage={10}
            totalItemsCount={this.state.totalRecord}
            pageRangeDisplayed={5}
            onChange={this.handlePageChange.bind(this)}
            />
          </div>
        </div>
                      
      </div>  
    </div>  
  </div>
   <div className="confirm-action-delete">
								<p className="confirm-action-delete-message"></p>
                
                
								<a href="javascript://" onClick={this.deleteConfirm.bind(this, "yes",this.state.driverid)} className="btn">Yes</a>
								<a href="javascript://" onClick={this.deleteConfirm.bind(this, "No")} className="btn">No</a>
								<span class="close-support" onClick={this.deleteConfirm.bind(this, "No")}  >X</span>
						 </div> 
    </div>
    );
  }
}

export default List;